export default {
  methods: {
    clicked(value) {
      alert(value);
    }
  }
};